import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Message } from "semantic-ui-react";
import { Form, Input, Button } from "formik-semantic-ui";
import { createMCCE } from "./store/actions/index";
import { Auth } from "aws-amplify";
import { object, string } from "yup";
import { v4 } from "uuid";

const initialValues = {
  Description: "",
  NlpId: "",
};

export class NewMCCE extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { planGroupId } = this.props;
    return (
      <Modal trigger={<Button positive>New MCCE</Button>} closeIcon>
        <Modal.Header>Create a new MCCE</Modal.Header>
        <Modal.Content>
          <Form
            initialValues={initialValues}
            validationSchema={object({
              Description: string().required(),
              NlpId: string().required(),
            })}
            onSubmit={async (values, { resetForm, setSubmitting }) => {
              try {
                const authToken = (await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken();
                await this.props.createMCCE(authToken, {
                  ...values,
                  InsurancePlanGroup: planGroupId,
                  Id: v4(),
                });
                this.setState({ success: true, ...values });
                resetForm(initialValues);
              } catch (err) {
                console.error(err);
                this.setState({
                  success: false,
                  error: err,
                });
                setSubmitting(false);
              }
            }}
            render={() => (
              <>
                <Form.Children>
                  <Input
                    name="Description"
                    label="Description"
                    inputProps={{ placeholder: "Description" }}
                  />
                  <Input
                    name="NlpId"
                    label="Label"
                    inputProps={{ placeholder: "Label" }}
                  />
                </Form.Children>
                <Button.Submit>Submit</Button.Submit>
              </>
            )}
          />
          {this.state.success && (
            <Message success>
              <Message.Header>MCCE Created</Message.Header>
              <Message.Content>
                <p>Description: {this.state.description}</p>
                <p>Label: {this.state.NlpId}</p>
              </Message.Content>
            </Message>
          )}
          {!this.state.success && this.state.error && (
            <Message error>
              <Message.Header>
                Failed with {this.state.error.status} -{" "}
                {this.state.error.statusText}
              </Message.Header>
              <Message.Content>
                <pre style={{ overflow: "scroll" }}>{this.state.error.msg}</pre>
              </Message.Content>
            </Message>
          )}
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  { createMCCE }
)(NewMCCE);
